module.exports = __webpack_public_path__ + "img/system-back.ca02cf5d.png";